import { render, staticRenderFns } from "./trailerData.vue?vue&type=template&id=a662ea08&scoped=true"
import script from "./trailerData.vue?vue&type=script&lang=js"
export * from "./trailerData.vue?vue&type=script&lang=js"
import style0 from "./trailerData.vue?vue&type=style&index=0&id=a662ea08&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a662ea08",
  null
  
)

export default component.exports